module.exports = __webpack_public_path__ + "img/caja_cajas.7ced517d.png";